module.exports = "#client-form {\n  display: flex;\n  flex-direction: column;\n  gap: 10px; }\n"